<nav class="nav nav-secondary mixed-loyalty-nav shadow">
  <!--Account-->
  <a
    class="nav-item"
    [routerLink]="['/account']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
    attr.aria-label="{{ 'account.nav.account.screenreader' | translate : { fgbdefault: 'Move to Account page' } }}"
  >
    <label class="text-uppercase">{{ 'account.nav.profile' | translate }}</label>
  </a>

  <!--Activity-->
  <a
    class="nav-item"
    [routerLink]="['/activity']"
    [routerLinkActive]="'active'"
    [routerLinkActiveOptions]="{ exact: true }"
    attr.aria-label="{{ 'account.nav.activity.screenreader' | translate : { fgbdefault: 'Move to activity page' } }}"
  >
    <label class="text-uppercase">{{ 'account.nav.activity' | translate }}</label>
  </a>
</nav>
